// Library entry. Importing this bundle self-registers the custom element, so the
// host only ever needs <script src=".../viewer.js"></script>.

import { MakistryAssemblyViewer } from "./element/MakistryAssemblyViewer";

if (!customElements.get("makistry-assembly-viewer")) {
  customElements.define("makistry-assembly-viewer", MakistryAssemblyViewer);
}

export { MakistryAssemblyViewer };
export type { AssemblyGraph, StationId } from "./graph/types";

declare global {
  interface HTMLElementTagNameMap {
    "makistry-assembly-viewer": MakistryAssemblyViewer;
  }
}
